var actionSkipLink = function (id) {
    var elem = $("#" + id);

    elem.focus();
    scrollToView(elem, 0);
};